import React from 'react';
import { Box, Skeleton } from '@mui/material';

const DayTimingSkeleton = () => (
    <Box
        className="day-accordion"
        sx={{
            px: 2,
            py: 1.5,
            mb: 2,
            borderRadius: "12px",
            border: "1px solid #e0e0e0",
            bgcolor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            height: "64px",
        }}
    >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Skeleton variant="circular" width={10} height={10} animation="wave" />
            <Skeleton variant="text" width={85} height={24} animation="wave" />
            <Skeleton variant="text" width={180} height={20} animation="wave" sx={{ ml: 2.5, display: { xs: 'none', sm: 'block' } }} />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Skeleton variant="text" width={38} height={20} animation="wave" />
            <Skeleton variant="rectangular" width={42} height={26} animation="wave" sx={{ borderRadius: 13 }} />
            <Skeleton variant="circular" width={22} height={22} animation="wave" sx={{ ml: 1 }} />
        </Box>
    </Box>
);

const RestaurantTimingsSkeleton = () => {
    return (
        <Box className="timings-body">
            {Array.from({ length: 7 }).map((_, idx) => (
                <DayTimingSkeleton key={idx} />
            ))}
        </Box>
    );
};

export default RestaurantTimingsSkeleton;
